// VehicleTypeService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  ChangeStatusVehicleTypeResponse,
  DeleteVehicleTypeResponse,
  GetVehicleTypeByIdResponse,
  GetVehicleTypeDropdownResponse,
  GetVehicleTypeResponse,
  VehicleTypeRequest,
  VehicleTypeResponse,
} from './interface';

export class VehicleTypeProfile extends BaseService {
  async createVehicleType(req: VehicleTypeRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.post<VehicleTypeResponse, FormData>(`${this.apiUrl}/api/vehicletypes`, formData, { headers });
  }

  async getVehicleType(params: PaginationParams) {
    return this.get<GetVehicleTypeResponse>(`${this.apiUrl}/api/vehicletypes/paged`, params);
  }

  async getVehicleTypeDropdown(params: PaginationParams) {
    return this.get<GetVehicleTypeDropdownResponse>(`${this.apiUrl}/api/vehicletypes/get`, params);
  }

  async updateVehicleType(req: VehicleTypeRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.put<VehicleTypeResponse, FormData>(`${this.apiUrl}/api/vehicletypes/update`, formData, { headers });
  }

  async deleteVehicleType(id: number) {
    return this.delete<DeleteVehicleTypeResponse>(`${this.apiUrl}/api/vehicletypes/${id}`);
  }

  async changeStatusVehicleType(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusVehicleTypeResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/vehicletypes/${active}/${id}`,
      req
    );
  }

  async getVehicleTypeByID(id: number) {
    return this.get<GetVehicleTypeByIdResponse>(`${this.apiUrl}/api/vehicletypes/${id}`);
  }
}
